import React from 'react';
import Typography from '@ntuctech/devex-tangram/Typography';
import { InfoIcon, Tooltip } from '@ntuctech/tangram-web';
import styled from 'styled-components';

const ProfileTitleSC = styled.div`
  flex: 0 0 10rem;

  @media (max-width: 767px) {
    flex: 1 0 100%;

    & h6 {
      color: #666666;
    }
  }
`;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ProfileTitle = (props) => {
  const { children, hasTooltip, tooltipText } = props;
  return (
    <ProfileTitleSC className="accProfile-title">
      <TextWrapper className="ndsHidden-xs-down">
        <Typography variant="body2">{children}</Typography>
        {hasTooltip && (
          <Tooltip message={tooltipText} placement="top">
            <InfoIcon style={{ marginLeft: '0.25rem' }} data-testid="myinfoHint" />
          </Tooltip>
        )}
      </TextWrapper>
      <TextWrapper className="ndsHidden-s-up">
        <Typography variant="subhead2">{children}</Typography>
        {hasTooltip && (
          <Tooltip message={tooltipText}>
            <InfoIcon style={{ marginLeft: '0.25rem' }} data-testid="myinfoHint" />
          </Tooltip>
        )}
      </TextWrapper>
    </ProfileTitleSC>
  );
};

export default ProfileTitle;
